// removed by extract-text-webpack-plugin
module.exports = {"root":"BasicPhone__root___32QiQ","content":"BasicPhone__content___1PCDx","hideOverflow":"BasicPhone__hideOverflow___34Nhp"};


//////////////////
// WEBPACK FOOTER
// ./src/themes/components/BasicPhone/BasicPhone.scss
// module id = 2228
// module chunks = 0